import { infoToast } from '../../../components/common/Toast';
import * as apiService from '../../api/student/api.service';
import { defaultReturn } from '../../../util/newStudent';
import { cleanCache } from '../../../util/common/appUtil';
import {
  authenticatedRequest,
  unauthenticatedRequest,
} from '../../api/newStudent/apiStudent.service';
import chatService from '../../chat/chat.service';
import { disconnectWebSocket } from '../../../lib/websocket';
import { apiUrl } from '../../../variables';

export interface IDataRecover {
  userType: string | undefined;
  login: string;
}

export interface IDataLogin {
  login?: string;
  password?: string;
  userType?: number;
  masterAccess?: string | null;
}

export interface IDataRegister {
  login: string | null;
  newPassword: string;
  passwordConfirmation: string;
}

export interface IDataUpdate {
  newPassword: string;
  passwordConfirmation: string;
  token: string;
}

interface IDataFirstAccess {
  login?: string | null;
  userType: number;
}

const authNewStudentService = {
  async authenticate(data: IDataLogin) {
    localStorage.clear();
    return await apiService.unauthenticatedRequest(
      `/new/sign-in`,
      'POST',
      data,
    );
  },

  async refreshToken() {
    const bearer = localStorage.getItem('userStudent');
    if (!bearer || bearer === 'null') {
      return undefined;
    }

    try {
      const response = await fetch(`${apiUrl}/new/refresh-token`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          Authorization: `Bearer ${bearer}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (data?.result && data?.data?.access_token) {
        authNewStudentService.setLoggedUser(data.data.access_token);
        return data;
      }

      return data;
    } catch {
      return undefined;
    }
  },

  async rememberPassword(dataRecover: IDataRecover) {
    const request = await unauthenticatedRequest(
      `/remember-password`,
      'POST',
      dataRecover,
    );

    return defaultReturn(request);
  },

  async updatePassword(dataUpdate: IDataUpdate) {
    try {
      const request = await unauthenticatedRequest(
        '/recover-password',
        'POST',
        dataUpdate,
      );
      return defaultReturn(request);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  async createFirstPassword(data: IDataRegister): Promise<{
    data: object;
    message: string[];
    result: boolean;
  }> {
    const request = await apiService.unauthenticatedRequest(
      '/student/create-password-first-login',
      'POST',
      data,
    );

    return defaultReturn(request);
  },

  async firstAccess(data: IDataFirstAccess): Promise<{
    data: {
      firstAccess: boolean;
    };
    message: string[];
    result: boolean;
  }> {
    const response = await apiService.unauthenticatedRequest(
      `/student/check-first-login`,
      'POST',
      data,
    );
    if (!response.result) return response;

    return defaultReturn(response);
  },

  setLoggedUser(data: string) {
    if (!data || data === 'undefined' || data === 'null') {
      return;
    }
    localStorage.setItem('userStudent', data.trim());
    localStorage.setItem('lastRefreshToken', new Date().getTime().toString());
  },

  async getLoggedUser() {
    const token = localStorage.getItem('userStudent');
    if (!token || token === 'null' || token === 'undefined') {
      return null;
    }

    const lastRefresh = localStorage.getItem('lastRefreshToken');
    if (lastRefresh && +lastRefresh + 1000 * 5400 < new Date().getTime()) {
      const request = await apiService.authenticatedRequest(
        '/validate-token',
        'GET',
      );
      if (request && request.data?.valid) {
        return token.trim();
      }
    }
    return token.trim();
  },

  cleanLoggerUser(isExpired: boolean = false) {
    if (isExpired) {
      infoToast('Sua sessão expirou, faça login novamente.');
    }

    setTimeout(async () => {
      await chatService.updateOnlineStatus(false);
      await disconnectWebSocket();

      await authenticatedRequest("/logout", "POST");
      
      localStorage.clear();
      cleanCache();

      return (window.location.href = '/new/aluno');
    }, 1000);
  },
};

export default authNewStudentService;
